import { from } from "rxjs"

import type { IAccountService } from "../AccountService"
import { mockAccountEvents } from "../mockData/accountData"

export const AccountService: IAccountService = {
  getAccountSummary: () => from(mockAccountEvents),
}
